<template>
     <div>
        <nav class="navbar navbar-light bg-white">
          <a class="navbar-brand" href="#">
            <img src="@/assets/logo.png" class="d-inline-block align-top" width="250">
          </a>
        </nav>
        <div class="row">
            <div class="col-md-4 mt-3 text-left">
                <strong>Olá</strong>, <i>{{user.name}}</i>!
            </div>
            <div class="col-md-6 mt-3">
                
            </div>
            <div class="col-md-2 mt-3 text-right">
                <a href="#" @click="exitSystem" class="link-padrao"><i class="fas fa-door-open mr-1"></i> Sair</a>
            </div>
        </div> 
     </div>    
</template>

<script>
export default {
    mounted(){
        this.topRules()
    },
    data(){
        return {
            user : {
                profile : null,
                name : null
            },
        }
    },
    methods:{
        topRules(){
            this.user.profile = localStorage.getItem("profile")
            this.user.name = localStorage.getItem("name")
        },
        exitSystem(){
            localStorage.removeItem("profile")
            localStorage.removeItem("token")
            localStorage.removeItem("name")
            localStorage.removeItem("cpf")
            location.href = '/'
        },
    }
}   
</script>
